import type {
  ImageLayer,
  LineLayer,
  ShapeLayer,
  StrokeStyle,
  TextLayer,
} from "../types.ts";

export const updateLayerStrokeStyle = (
  layer: ShapeLayer | LineLayer | ImageLayer | TextLayer,
  strokeStyle: StrokeStyle,
) => {
  layer.strokeStyle = strokeStyle;

  switch (strokeStyle) {
    case "solid":
      layer.set({
        strokeDashArray: undefined,
      });
      break;
    case "dashed":
      layer.set({
        strokeDashArray: [10, 5],
      });
      break;
    case "dotted":
      layer.set({
        strokeDashArray: [2, 5],
      });
      break;
    case "dash-dot":
      layer.set({
        strokeDashArray: [10, 5, 2, 5],
      });
      break;
  }
};
